import React from "react";
import CheckoutFieldRow from "./CheckoutFieldRow";
import CheckoutActionButton from "./CheckoutActionButton";
import CheckoutMoneyInput from "./CheckoutMoneyInput";

interface DiscountInputRowProps {
  label: string;
  placeholder: string;
  value: string | number;
  isApplied: boolean;
  onApply: () => void;
  onRemove: () => void;
  onChange: (value: string) => void;
  disabled?: boolean;
  isApplyDisabled?: boolean;
  error?: React.ReactNode;
  isMoneyInput?: boolean;
  applyLabel?: string;
  appliedLabel?: string;
  removeLabel?: string;
}

const DiscountInputRow: React.FC<DiscountInputRowProps> = ({
  label,
  placeholder,
  value,
  isApplied,
  onApply,
  onRemove,
  onChange,
  disabled = false,
  isApplyDisabled = false,
  error,
  isMoneyInput = false,
  applyLabel = "Apply",
  appliedLabel = "Applied",
  removeLabel = "Remove",
}) => (
  <CheckoutFieldRow
    label={label}
    actionLabel={isApplied ? removeLabel : undefined}
    onAction={onRemove}
    actionDisabled={disabled}
    error={error}
  >
    <div className="split-discount-control-row">
      {isMoneyInput ? (
        <CheckoutMoneyInput
          inputMode="decimal"
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          onChange={onChange}
        />
      ) : (
        <input
          type="text"
          className="form-control no_spring_input"
          placeholder={placeholder}
          disabled={disabled}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      )}

      <CheckoutActionButton
        disabled={isApplied || isApplyDisabled || disabled}
        onClick={onApply}
      >
        {isApplied ? appliedLabel : applyLabel}
      </CheckoutActionButton>
    </div>
  </CheckoutFieldRow>
);

export default DiscountInputRow;
